// useBallotParties.js
//
// A state's next ballot: { date, label, parties, candidates, truncated }.
// parties is the ballot's own parties_on_ballot, largest first; candidates is
// the certified list the party page filters by party_key. Each party row carries its label, its
// candidate count and, where the label names a party with a national
// committee, its party_key. Labels that name no party (Independent, Write-In)
// come back with party_key null and a why_no_party, and are kept.

import useApi2Resource from './useApi2Resource';
import { fetchBallotParties } from '../utils/parties';

export default function useBallotParties(stateAbbr) {
  return useApi2Resource(stateAbbr ? () => fetchBallotParties(stateAbbr) : null, [stateAbbr]);
}